import api from '.';

const metodos = (tipo) => {
    return {
        consulta: (uuid) => api.get(`/${tipo}/editar/${uuid}`),
        editar: (dados) => api.post(`/${tipo}/editar/`, dados),
        editarComPatch: (dados) => api.patch(`/${tipo}/editar/`, dados),
        editarComFormData: (dados) =>
            api.post(`/${tipo}/editar/`, dados, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }),
        cadastrarComFormData: (dados) =>
            api.post(`/${tipo}/cadastrar/`, dados, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }),
        cadastrar: (dados) => api.post(`/${tipo}/cadastrar/`, dados),
        deletar: (selectedRow) => api.post(`/${tipo}/deletar/`, selectedRow),
        listar: (start, size, filters, filtersMode, globalFilter, sorting, tipoConsulta, operacaoId) =>
            api.get(`/${tipo}/listar/`, {
                params: {
                    start,
                    size,
                    filters,
                    filtersMode,
                    globalFilter,
                    sorting,
                    tipoConsulta,
                    operacaoId,
                },
            }),
        listarObj: ({
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            tipoConsulta,
            operacaoId,
            empresaId,
            limitarRegistros = false, //faz com que o usuario apenas visualize seus registros
            operacaoSigla, //cria filtros específicos pela operação
            homologationId,
            natureza, // indica a natureza da operação para operação com ambos, CFR a natureza pode resolver sendo Saida e Entrada
        }) =>
            api.get(`/${tipo}/listar/`, {
                params: {
                    start,
                    size,
                    filters,
                    filtersMode,
                    globalFilter,
                    sorting,
                    tipoConsulta,
                    operacaoId,
                    empresaId,
                    limitarRegistros,
                    operacaoSigla,
                    homologationId,
                    natureza,
                },
            }),
        edit: (uuid, operacaoId) =>
            api.get(`/${tipo}/edit/`, {
                params: {
                    uuid,
                    operacaoId,
                },
            }),

        duplicidade: (descricao) =>
            api.get(`/${tipo}/duplicidade/`, {
                params: {
                    descricao,
                },
            }),

        /*
            Esse { responseType: "arraybuffer" } deve ser o terceiro argumento da requisição post, 
            que é onde as configurações da requisição são passadas. 
        */
        imprimir: (url, obj = {}) => api.post(`/${tipo}/imprimir/?${url.toString()}`, obj, { responseType: 'arraybuffer' }),
        imprimirCustos: (url, obj = {}) =>
            api.post(`/${tipo}/imprimirCustos/?${url.toString()}`, obj, { responseType: 'arraybuffer' }),

        imprimirMes: async (params, obj) => {
            return await api.post(`/${tipo}/imprimirMes?${params.toString()}`, obj, {
                responseType: 'blob',
            });
        },
        imprimirDRE: async (params, obj) => {
            return await api.post(`/${tipo}/imprimirDRE?${params.toString()}`, obj, {
                responseType: 'blob',
            });
        },
    };
};

const CRUDs = {
    ajuda: { ...metodos('ajuda') },
    ambiente: { ...metodos('ambiente') },
    almoxarifado: { ...metodos('almoxarifado') },
    almoxarifadoMovimento: { ...metodos('almoxarifadoMovimento') },
    anilox: { ...metodos('anilox') },
    arquivoDocumento: { ...metodos('arquivoDocumento') },
    arquivoDocumentoTipo: { ...metodos('arquivoDocumentoTipo') },
    assinatura: { ...metodos('assinatura') },
    balancete: { ...metodos('balancete') },
    bobina: { ...metodos('bobina') },
    caixa: { ...metodos('caixa') },
    cargo: { ...metodos('cargo') },
    centroCusto: { ...metodos('centroCusto') },
    centroCustoLimite: { ...metodos('centroCustoLimite') },
    cest: { ...metodos('cest') },
    cfop: { ...metodos('cfop') },
    cilindro: { ...metodos('cilindro') },
    conta: { ...metodos('conta') },
    cor: { ...metodos('cor') },
    documento: { ...metodos('documento') },
    eleicao: { ...metodos('eleicao') },
    empresa: { ...metodos('empresa') },
    embalagem: { ...metodos('embalagem') },
    equipe: { ...metodos('equipe') },
    forma: { ...metodos('forma') },
    grupo: { ...metodos('grupo') },
    integracaoCliente: {
        ...metodos('integracaoCliente'),
        rotacionar: (dados) => api.post('/integracaoCliente/rotacionar/', dados),
        alterarStatus: (dados) => api.patch('/integracaoCliente/status/', dados),
        listarEmpresasPermitidas: (uuid) => api.get(`/integracaoCliente/${uuid}/empresas`),
        substituirEmpresasPermitidas: (uuid, empresaIds, configuracoes) =>
            api.put(`/integracaoCliente/${uuid}/empresas`, {
                empresaIds,
                ...(configuracoes !== undefined ? { configuracoes } : {}),
            }),
        listarTransformacoesRecebimento: (uuid, empresaId, operacaoRecebimentoId) =>
            api.get(`/integracaoCliente/${uuid}/transformacoes-recebimento`, {
                params: {
                    empresaId,
                    operacaoRecebimentoId,
                },
            }),
    },

    homologation: { ...metodos('homologation') },
    homologationItem: { ...metodos('homologation/item') },
    homologationPessoa: { ...metodos('homologation/item/pessoa') },
    homologationRegistro: { ...metodos('homologation/item/registro') },
    homologationAssinatura: { ...metodos('homologation/item/Assinatura') },

    indexador: { ...metodos('indexador') },
    lancamentoConta: { ...metodos('lancamentoConta') },
    mapaAbastecimento: { ...metodos('mapaAbastecimento') },
    maquina: { ...metodos('maquina') },
    menu: { ...metodos('menu') },
    menuSub: { ...metodos('menuSub') },

    movimento: { ...metodos('movimento') },

    municipio: { ...metodos('municipio') },
    ncm: { ...metodos('ncm') },
    nivel: { ...metodos('nivel') },
    operacao: { ...metodos('operacao') },
    operacaoParametro: { ...metodos('operacaoParametro') },
    pais: { ...metodos('pais') },
    parametro: { ...metodos('parametro') },
    pdc: { ...metodos('PDC') },
    permissoes: { ...metodos('permissoes') },
    perfisPermissao: {
        catalogo: () => api.get('/perfisPermissao/catalogo'),
        listar: (empresaId) => api.get('/perfisPermissao/listar', { params: { empresaId } }),
        consultar: (empresaId, perfilPermissaoId) =>
            api.get('/perfisPermissao/consultar', { params: { empresaId, perfilPermissaoId } }),
        salvar: (dados) => api.post('/perfisPermissao/salvar', dados),
        aplicar: (dados) => api.post('/perfisPermissao/aplicar', dados),
        vinculo: (empresaId, pessoaId) => api.get('/perfisPermissao/vinculo', { params: { empresaId, pessoaId } }),
        desvincular: (dados) => api.post('/perfisPermissao/desvincular', dados),
        deletar: (dados) => api.post('/perfisPermissao/deletar', dados),
    },
    pessoaEmpresa: { ...metodos('pessoaEmpresa') },

    produto: { ...metodos('Produto') },
    produtoBem: { ...metodos('ProdutoBem') },
    produtoLIM: { ...metodos('ProdutoLIM') },
    produtoVTR: { ...metodos('ProdutoVTR') },
    plantao: { ...metodos('plantao') },
    plantaoTipo: { ...metodos('plantaoTipo') },
    prazo: { ...metodos('prazo') },
    produtoModelo: { ...metodos('produtoModelo') },

    rh: { ...metodos('rh') },
    rhAfastamentos: { ...metodos('rh/Afastamentos') },
    rhComprovantes: { ...metodos('rh/Comprovantes') },
    rhDependentes: { ...metodos('rh/dependentes') },
    rhDeclaracaoTipos: { ...metodos('rh/declaracaoTipos') },
    rhExame: { ...metodos('rh/exames') },
    rhFerias: { ...metodos('rh/ferias') },
    vacinacao: { ...metodos('rh/vacinacao') },
    declaracoes: { ...metodos('rh/declaracoes') },

    setor: { ...metodos('setor') },
    tabelaPreco: { ...metodos('tabelaPreco') },
    tributacao: { ...metodos('tributacao') },
    situacao: { ...metodos('situacao') },
    uf: { ...metodos('uf') },
    unidade: { ...metodos('unidade') },
    usuarioPermitido: { ...metodos('usuarioPermitido') },
    vacina: { ...metodos('vacina') },
};
export default CRUDs;
